import React from "react";
import "./ProductSpecs.css";

export default function ProductSpecs({ product }) {

  if (!product || !product.specifications || !product.specifications.length) {
    return null;
  }

  return (
    <div className="product-specs">
      <h4 className="section-title">Specifications</h4>
      <ul className="specs-list">
        {product.specifications.map((spec, key) => (
          <li key={key}>
            <span className="spec-key">{spec.key}</span>
            <span className="spec-value">{spec.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

